import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IResendAlertPayload } from "../../../common/types/alertsTypes";
import { Status } from "../../../common/constants";
import { resendAlertUrl } from "../../../config";
import api from "../../../api";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const RESEND_ALERT: string = "resendAlert";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null,
};

interface IResendAlertResponse {
  message: string;
}

export const resendAlert = createAsyncThunk(
  RESEND_ALERT,
  async (payload: IResendAlertPayload, { rejectWithValue }) => {
    try {
      const response = await api.post<IResendAlertResponse>(
        resendAlertUrl,
        payload
      );
      const resendAlertResponse: IResendAlertResponse = response.data;
      return resendAlertResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const resendAlertSlice = createSlice({
  name: RESEND_ALERT,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resendAlert.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(resendAlert.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(resendAlert.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

type Selector = {
  resendAlert: ReturnType<
    typeof resendAlertSlice.reducer
  >;
};

export const selector = (store: Selector) => store['resendAlert'];
export default resendAlertSlice.reducer;
